import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { curdActions } from "../../reduxCURD/actions";
import _ from "lodash";
import { languageService } from "../../Language/language.service";
import { CRUDFunction } from "../../reduxCURD/container";
import { createMsgList } from "../../reduxRelated/actions/msgListAction";
import { jsonDataforJourneyPlan } from "./data";
import ThisTable from "../Common/ThisTable";
import { ToastService } from "../../utils/toastify";
class Simulator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      workPlanTemplates: [],
      data: "",
      date: "",
      code: "",

    };

    this.handlePageSave = this.handlePageSave.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);

    this.columns = [
      {
        Header: languageService("Inspection Name"),
        accessor: "title",
        minWidth: 80,
      },
    ];
  }

  componentDidMount() {
    // this.props.getWorkPlanTemplates();
  }

  componentDidUpdate(prevProps) {
    if (this.props.msgListActionType === "MSGLIST_CREATE_SUCCESS" && this.props.msgListActionType !== prevProps.msgListActionType) {
      ToastService.Success("Journey Plan Updated Successfully!");
    }

    if (this.props.msgListActionType === "MSGLIST_CREATE_FAILURE" && this.props.msgListActionType !== prevProps.msgListActionType) {
      ToastService.Error("Error:", "Journey Plan Update Failure");
    }

    if (
      this.props.workPlanTemplateActionType === "WORKPLANTEMPLATES_READ_SUCCESS" &&
      this.props.workPlanTemplateActionType !== prevProps.workPlanTemplateActionType
    ) {
      this.setState({
        workPlanTemplates: this.props.workPlanTemplates,
      });
    }
  }

  sendDummyCall() {
    const { data } = this.state;
    let isValid = false;
    try {
      JSON.parse(data);
      isValid = true;
    } catch (error) {
      ToastService.Error("Error:", error.message);
    }

    if (isValid) {
      let optParam1JSON = JSON.parse(data);
      console.log(new Date());
      let finalData = [
        {
          listname: "JourneyPlan",
          code: this.state.code ? this.state.code : "",
          desc: this.state.date ? new Date(this.state.date) : new Date(),
          optParam1: JSON.stringify(optParam1JSON),
        },
      ];

      this.props.createMsgList(finalData);
    }
  }

  handlePageSave(page) {
    this.setState({
      page: page,
    });
  }

  handleDataChange(event) {
    event.target.name === "data"
      ? this.setState({ data: event.target.value })
      : event.target.name === "code"
      ? this.setState({ code: event.target.value })
      : this.setState({ date: event.target.value });
  }

  // setSelectedWorkPlanTemplate(e, wp) {
  //   this.setState({
  //     //if user is pressed first time then the componenet did update prev state function must not be called
  //     // selectedUser: user.original,
  //     // selectedLocations: { target: { name: "locationIds", value: user.original.assignedLocations } },
  //     // isButtonDisabled: true,
  //   });
  // }

  render() {
    const { data, isValidJSON, jsonError } = this.state;
    return (
      <React.Fragment>
        {/* <ThisTable
          tableColumns={this.columns}
          tableData={this.state.workPlanTemplates}
          pageSize={15}
          minRows={1}
          pagination={true}
          forDashboard={false}
          handlePageChange={(page) => this.handlePageSave(page)}
          page={this.state.page}
          height={"auto"}
          handleSelectedClick={this.setWorkPlanTemplate}
          onClickSelect
        /> */}
        <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column", padding: "20px" }}>
          <label>Code</label>
          <input value={this.state.code} name="code" onChange={this.handleDataChange} />

          <br></br>
          <label>Date</label>
          <input type="datetime-local" name="date" value={this.state.date} onChange={this.handleDataChange} />

          <br></br>
          <label>optParam1</label>
          <textarea rows="15" cols="150" id="data" name="data" value={this.state.data} onChange={this.handleDataChange}></textarea>
          <br></br>
          <button onClick={() => this.sendDummyCall()}>Submit</button>
        </div>
      </React.Fragment>
    );
  }
}

const getWorkPlanTemplates = curdActions.getWorkPlanTemplates;

let variables = {
  msgListReducer: { msgList: [], msgListActionType: null },
  workPlanTemplateReducer: { workPlanTemplates: [] },
};

let actionOptions = {
  create: true,
  update: true,
  read: true,
  delete: true,
  others: {
    createMsgList,
    getWorkPlanTemplates,
  },
};

let containerReducers = ["msgListReducer", "workPlanTemplateReducer"];
let SimulatorContainer = CRUDFunction(Simulator, "simulator", actionOptions, variables, containerReducers);
export default SimulatorContainer;



// WEBPACK FOOTER //
// ./src/components/Simulator/Simulator.js